import { withRouter } from "react-router-dom";

import Grid from "@mui/material/Grid";

import Portal from "../ui/portal";
import PortalAppBar from "../ui/portalAppBar";
import PortalGridContent from "../ui/portalGridContent";
import BotpressChat from "../widgets/botpressChat";

const HyperbaricPartnerPortal = props => {
  return (
    <Portal>
      <PortalAppBar hideMenu="true" />
      <PortalGridContent>
        <Grid item xs={0} md={1} lg={3} />
        <Grid item xs={12} md={10} lg={6}>
          <BotpressChat widgetSize="large" />
        </Grid>
        <Grid item xs={0} md={1} lg={3} />
      </PortalGridContent>
    </Portal>
  );
};

export default withRouter(HyperbaricPartnerPortal);
